"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonType = void 0;
var AddonType;
(function (AddonType) {
    AddonType["Accommodation"] = "Accommodation";
    AddonType["Activity"] = "Activity";
    AddonType["Transportation"] = "Transportation";
    AddonType["ExtraTrip"] = "ExtraTrip";
    AddonType["Other"] = "Other";
})(AddonType = exports.AddonType || (exports.AddonType = {}));
//# sourceMappingURL=Addon.js.map